import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';
import moment from 'moment-timezone';
import {connect} from 'react-redux';
import {createSchedule, updateSchedule} from '../../actions/ClientActions';
import StaffMemberPicker from '../StaffMemberPicker';
import Assert from '../../assert/Assert';
import {BootstrapForm, FormGroup, DateInput} from '../bootstrap/Form';
import ClientContactsDropdown from '../clients/ClientContactsDropdown';
import {callers, australians} from '../../reducers/users';

var makeInitialInputs = (props) => {
    var initialEventType = props.eventType || 'training';
    var initialLocation = props.location || 'web';

    var getDefaultAssignIds = (users, authUser) => {
        if(users.length == 1) {
            return [users[0].id]    ;
        }

        var isShamima = authUser.email == "shamima@fergusapp.com";
        if(isShamima && initialEventType != 'phonecall') {
            return [];
        }

        if(! callers.includes(authUser.email)) {
            return [];
        }

        return [authUser.id];
    };

    var defaultAssignedUserIds = props.assignedUserIds && props.assignedUserIds.length ? props.assignedUserIds : getDefaultAssignIds(props.users, props.authUser);

    var getDefaultContactId = (props) => {
        if(props.contactId) {
            return props.contactId;
        }

        return props.contacts.length ? props.contacts[0].id : '';
    };

    var inputs = {
      assignedUserIds: {
          value: defaultAssignedUserIds,
          validators: [{
              rule: input => input.length > 0,
              errorMessage: 'You must assign someone.'
          }]
      },
      startDate : {
          value: props.date ? moment(props.date).format("YYYY-MM-DD") : null,
          validators: [{
              rule: input => input != null,
              errorMessage: 'Please enter start date'
          }]
      },
      startTime : {
          value: props.date ? moment(props.date).format("HH:mm") : moment().format("HH:mm"),
          validators: [{
              rule: input => input != null,
              errorMessage: 'Please enter start time'
          }]
      },
      eventType : {
          value: initialEventType
      },
      location : {
          value: initialLocation
      },
      description: {
          value: props.description ? props.description : '',
          validators: [{
              rule: Assert.minLength(1),
              errorMessage: 'Description must not be empty'
          }]
      },
      participatingContactId: {
          value: getDefaultContactId(props)
      }
    };

    if(props.scheduleId) {
        inputs.notes = {
            value: props.notes || ''
        };
    }

    return inputs;
};

@connect(
    state => ({
        isSavingSchedule: state.modal.isSavingSchedule,
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        authUser: state.auth.user,
        country: state.activeClient.client.country,
        clientMeta: state.activeClient.client.meta,
        users: state.users.users
    }),
    { createSchedule, updateSchedule },
    null,
    { withRef: true }
)
export default class ScheduleForm extends Component {
    static propTypes = {
        clientId: React.PropTypes.string.isRequired,
        contacts: React.PropTypes.array.isRequired
    };
    constructor(props){
        super(props);

        var inputs = makeInitialInputs(this.props);

        this.state = {
            datePickerVisible: false,
            inputs,
            errors: {}
        };

        this.isPhoneCall = this.isPhoneCall.bind(this);
    }
    componentDidMount(){
        findDOMNode(this.refs.description).focus();
    }
    isPhoneCall() {
        return this.state.inputs.eventType.value == 'phonecall';
    }
    saveSchedule(e) {
        if(e) {
            e.preventDefault();
        }

        if(this.refs.form.isValid()) {
            var formData = this.refs.form.getFormData();
            var {startDate, startTime} = formData;
            var scheduleData = {
                ...formData,
                startDate: moment(`${startDate} ${startTime}`),
                clientId: this.props.clientId
            };

            if (this.props.scheduleId) {
                this.props.updateSchedule(this.props.scheduleId, scheduleData);
            } else {
                this.props.createSchedule(scheduleData);
            }

            var inputs = makeInitialInputs(this.props);
            this.setState({inputs});
        } else {
            this.setState({errors: this.refs.form.getErrors()});
        }
    }
    textareaKeyUp(e){
        e.target.style.overflow = 'hidden';
        e.target.style.height = '80px';
        var textareaHeight = Math.min(e.target.scrollHeight + 10, 380);
        e.target.style.height = textareaHeight + 'px';
    }
    handleInputChange(e){
        var inputs = this.state.inputs;
        inputs[e.target.name].value = e.target.value;
        this.setState({inputs});
    }
    timeChange(e){
        this.setState({time : e.target.value});
    }
    handleContactChange(participatingContactId) {
        var inputs = this.state.inputs;
        inputs.participatingContactId.value = participatingContactId;
        this.setState(inputs);
    }
    handleUserIdsChanged(assignedUserIds) {
        var inputs = this.state.inputs;
        inputs.assignedUserIds.value = assignedUserIds;
        this.setState({inputs});
    }
    blurDate(e){
        e.preventDefault();
        this.setState({
            datePickerVisible : false
        })
    }
    dateChange(dateString, _moment){
        var inputs = this.state.inputs;
        inputs.startDate.value = dateString;

        this.setState({inputs});
    }
    dateClick(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            datePickerVisible : ! this.state.datePickerVisible
        });
    }
    renderTimeInClientsTz() {
        var timeInput = this.state.inputs.startTime.value;
        if(! timeInput || this.props.country == 'New Zealand') {
            return null;
        }

        var timezone = this.props.client.timezone;
        if(! timezone) {
            return null;
        }

        var timeInTz = moment(timeInput, "HH:mm").tz(timezone).format("HH:mm a");

        var style={marginTop: '5px', marginBottom: '0px'};
        if(this.props.country == 'Australia' && ! australians.includes(this.props.authUser.email)) {
            return (<p style={style}>{`Local Time ${timeInTz} (${timezone})`}</p>);
        }

        return (<p style={style}>{`Local Time ${timeInTz} (${timezone})`}</p>);
    }
    render() {
        var eventType = this.state.inputs.eventType.value;
        var location = this.state.inputs.location.value;

        var hideMeetingLocation = this.isPhoneCall(); //eventType != 'demo' && eventType != 'training';

        return (
            <BootstrapForm ref="form" onSubmit={this.saveSchedule.bind(this)} inputs={this.state.inputs} className="form-horizontal">
                {!this.props.hideEventTypes &&
                <div className="control-group row" style={{marginBottom: '15px'}}>
                    <label className="control-label col-md-3">Schedule Type</label>

                    <div className="col-m-6">
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={eventType == 'demo'} name="eventType" value="demo"
                                   required/>Demo
                        </label>
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={eventType == 'training'} name="eventType"
                                   value="training" required/>Training
                        </label>
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={this.isPhoneCall()} name="eventType"
                                   value="phonecall" required/>Call Back
                        </label>
                    </div>
                </div>
                }
                { ! hideMeetingLocation &&
                <div className="control-group row" style={{marginBottom: '15px'}}>
                    <label className="control-label col-md-3">Location:</label>
                    
                    <div className="col-m-6">
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={location == 'off site'} name="location" value="off site"
                                   required/>Off Site
                        </label>
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={location == 'at office'} name="location" value="at office"
                                   required/>At Office
                        </label>
                        <label className="radio-inline">
                            <input type="radio" onChange={this.handleInputChange.bind(this)}
                                   checked={location == 'web'} name="location" value="web"
                                   required/>Web {eventType}
                        </label>
                    </div>
                </div>
                }
                <FormGroup defaultText='Start Date' errors={this.state.errors.startDate}>
                    <div className="col-sm-7 input-group">
                        <span className="input-group-addon"><i className="fa fa-clock-o"></i></span>
                        <DateInput
                            date={this.state.inputs.startDate.value}
                            onChange={this.dateChange.bind(this)} />
                    </div>
                </FormGroup>
                <FormGroup defaultText='Start Time' errors={this.state.errors.startTime}>
                    <div className="input-group date col-sm-4">
                        <span className="input-group-addon"><i className="fa fa-clock-o"></i></span>
                        <input type="time"
                               name="startTime"
                               className="form-control"
                               onChange={this.handleInputChange.bind(this)}
                               value={this.state.inputs.startTime.value}
                               data-date-format="dd/mm/yyyy" />
                    </div>
                    {this.renderTimeInClientsTz()}
                </FormGroup>
                <FormGroup defaultText='Description' errors={this.state.errors.description}>
                    <textarea
                        ref="description"
                        name="description"
                        placeholder="Enter description"
                        className="col-md-7"
                        value={this.state.inputs.description.value}
                        onChange={this.handleInputChange.bind(this)}
                        onKeyUp={this.textareaKeyUp.bind(this)}
                        style={{ height: "40px", borderColor : '#ccc', outline : 'none', resize : 'none' }}>
                    </textarea>
                </FormGroup>
                {this.isPhoneCall() &&
                <FormGroup defaultText='Contact'>
                    <ClientContactsDropdown value={this.state.inputs.participatingContactId.value} onChange={this.handleContactChange.bind(this)} />
                </FormGroup>
                }
                {this.props.scheduleId &&
                    <FormGroup defaultText='Notes' errors={this.state.errors.notes}>
                        <textarea
                            ref="notes"
                            name="notes"
                            placeholder="Edit notes"
                            className="col-md-7"
                            value={this.state.inputs.notes.value}
                            onChange={this.handleInputChange.bind(this)}
                            onKeyUp={this.textareaKeyUp.bind(this)}
                            style={{ height: "40px", borderColor : '#ccc', outline : 'none', resize : 'none' }}>
                        </textarea>
                    </FormGroup>
                }

                {this.props.users.length > 1 &&
                    <strong id="staff-picker-label" style={{display: 'block', marginBottom: '10px'}}>Staff members</strong>
                }
                {this.state.errors.assignedUserIds && this.state.errors.assignedUserIds.length &&
                    <p style={{color: '#f86c6b'}}>{this.state.errors.assignedUserIds[0]}</p>
                }
                {this.props.users.length > 1 &&
                    <StaffMemberPicker
                        callersOnly={true}
                        onSelectChange={this.handleUserIdsChanged.bind(this)}
                        onlyOneAssign={this.isPhoneCall()}
                        assignedUserIds={this.state.inputs.assignedUserIds.value}
                        selectPlaceHolder={"Select staff member involved"} />
                }
            </BootstrapForm>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/schedule/ScheduleForm.js